export default "__VITE_ASSET__49d6953c__"